export enum InvoiceStatus {
  Unknown = 0,
  Draft = 1,
  Cancelled = 2,
  Validated = 3,
}
